import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MetaDefinition } from '@angular/platform-browser';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { UniApiConfig } from '@sparro/app/core/config/api.config';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { User } from '@sparro/app/core/models/user.model';
import { UserService } from '@sparro/core/api/user/user.service';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit {
  compSlug: string;
  source: string;
  user: User;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public metaService: MetaService,
    private userService: UserService,
    private _apiConfig: UniApiConfig,
    private about: CompDetailService,
    public imageOptimizer: ImageOptimizerService
  ) {}

  ngOnInit(): void {
    this.compSlug = this.route.parent.snapshot.params.comp_slug;
    this.source = this._apiConfig.competitionUrl;
    this.getAuthUser();
    this.updateMetaInfo();
  }

  getAuthUser(): void {
    this.userService.userInitialized.subscribe((initialized: boolean) => {
      if (initialized) {
        this.userService.user.subscribe((user: User) => {
          this.user = user;
        });
      }
    });
  }

  updateMetaInfo(): void {
    this.about.fetchCompetition(this.compSlug, (competition: any) => {
      let metaInfo: MetaDefinition[] = [];
      const title =
        `${competition.title} ${competition.disciplines[0]?.name} Competition | ` +
        (competition.location?.name
          ? competition.location.name
          : competition.location?.country?.name) +
        ` | Discussions`;
      const description = `View and initiate discussion on ${competition.title}, ${
        competition.location?.name ? competition.location.name : competition.location.country.name
      }.`;
      const image = competition.image ? this.renderImage(competition.image) : '';
      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description.slice(0, 100) },
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }
  // TODO: Get comments code
}
